import {
  KeyboardSensor,
  PointerSensor,
  type SensorDescriptor,
  type SensorOptions,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

/**
 * Hook that creates consistent DnD sensors for multi-value field editors.
 *
 * Configures:
 * - PointerSensor with 8px activation distance (prevents accidental drags)
 * - KeyboardSensor with sortable coordinates (accessibility)
 *
 * Use this utility to ensure all multi-value editors (PropertyInput, CompositeMultiValueEditor)
 * have identical drag-and-drop behavior.
 *
 * @returns Configured sensors for use with DndContext
 */
export function useMultiValueSensors(): SensorDescriptor<SensorOptions>[] {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
}
